import { Alert, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Alert)``;

export const Dot = styled(Box)`
  width: 3px;
  height: 3px;
  background: ${(p) => p.theme.palette.grey[600]};
  border-radius: 50%;
`;
